// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__SxJMQ","active":"Breadcrumb_active__kMdEO"};